import {Injectable} from '@angular/core';


import {ApiService} from './api.service';

@Injectable()
export class ProfileService {

    
    constructor( private apiService: ApiService) {}

    getProfile() {
        return this.apiService.http_get('/profile/edit');
    }
    
    updateProfile(profile) {
        return this.apiService.http_post('/profile/updateProfile',profile);
    }
    resetPassword(profile) {
        return this.apiService.http_post('/profile/resetPassword',profile);
    }
    
    getUserProfile() {
        return this.apiService.http_get('/profile/user');
    }
    
    updateUserProfile(profile) {
        return this.apiService.http_post('/profile/updateUserProfile',profile);
    }
    resetUserPassword(profile) {
        return this.apiService.http_post('/profile/resetUserPassword',profile);
    }
}


// WEBPACK FOOTER //
// /var/www/html/LASO/laso-client/src/app/_services/profile.service.ts